export default __webpack_public_path__ + "static/cf-5749f5d8c1ac1ba23191912f24c55972.png";